<template>
    <div
      :class="`
      workbench-workpackage-info-box
      font-weight-light
      t-rounded
      t-shadow
      ${color}
      ${text_color}--text
      ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}
      `
      "
      :style="`width: ${width}; height: ${height}`"
      >
      <slot name="content"/>
      <div class="workbench-workpackage-info-box-button-top self-centered">
        <slot name="button-top"/>
      </div>
      <div class="workbench-workpackage-info-box-button-right self-centered">
        <slot name="button-right"/>
      </div>
      <div class="workbench-workpackage-info-box-button-bottom self-centered">
        <slot name="button-bottom"/>
      </div>
      <div class="workbench-workpackage-info-box-button-left self-centered">
        <slot name="button-left"/>
      </div>
    </div>
</template>
<script>
  export default {
    props: ['width', 'height', 'color', 'text_color'],
  }
</script>
<style>
  .workbench-workpackage-info-box {
    position: relative;
    height: 400px;
    width: 600px;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
  }
  .workbench-workpackage-info-box-button-top {
    position: absolute;
    top: 47px;
    left: 50%;
  }
  .workbench-workpackage-info-box-button-right {
    position: absolute;
    top: 50%;
    left: calc(100% - 12px);
  }
  .workbench-workpackage-info-box-button-bottom {
    position: absolute;
    top: calc(100% - 12px);
    left: 50%;
  }
  .workbench-workpackage-info-box-button-left {
    position: absolute;
    top: 50%;
    left: 12px;
  }
</style>
